import React, {Component} from 'react';
import styled from 'styled-components';
import {connect} from 'react-redux';
import {Link} from '@reach/router';
import {Line as ProgressLine} from 'rc-progress';
import FontAwesome from 'react-fontawesome';

const FooterWrapper = styled.footer `
  z-index: 99;
  position: fixed;
  bottom: 0;
  height: 75px;
  background: linear-gradient(180deg, #c21e3d 0%, #af1230 100%);
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const FilterSearchButton = styled.button `
  right: 0.01%;
  bottom: 50px;
  position: absolute;
  height: 3.2rem;
  width: 3.2rem;
  border-radius: 5rem;
  background: linear-gradient(180deg, #c21e3d 60%, rgba(255,0,0,0) 0%);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  justify-self: center;
  border: none;
  transition: all 0.5s;
  &::after {
    content: 'X';
    color: white;
    font-size: 1.5rem;
  }
  &:focus {
    outline: none;
  }
  &:hover {
    cursor: pointer;
  }
  }
`;

const StyledInnerContainer = styled.div `
  height: 100%;
  width: 70%;
  display: grid;
  grid-template-columns: 5rem 1fr;
  grid-template-rows: 1fr;
  align-items: center;
  @media (max-width: 700px) {
    width: 100%;
  }
`;

const StyledTrackInfoDiv = styled.div `
  display: flex;
  flex-direction: column;
`;

const StyledProgressLine = styled(ProgressLine)`
  width: 90%;
  height: 2px;
`;

const StyledTimelineTextDiv = styled.div `
  width: 90%;
  display: flex;
  justify-content: space-between;
`;

const StyledTimelineText = styled.p `
  display: block;
  line-height: 1px;
  font-size: 0.7em;
`;

const PlayIconCircle = styled.button `
  top: 12.5px;
  bottom: 12.5px;
  left: 12.5px;
  align-self: center;
  margin-bottom: 2rem;
  position: relative;
  height: 50px;
  width: 50px;
  border-radius: 50%;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: none;
  transition: all 0.5s;
  &:focus {
    outline: none;
  }
  &:hover {
    cursor: pointer;
    opacity: 0.5;
  }
`;

const PlayIcon = styled(FontAwesome)`
  position: absolute;
  color: #af1230;
  font-size: 2rem;
  line-height: 50px;
  left: ${props => props.cssleft};
`;

const BodyText = styled.p `
  font-family: 'Open Sans', sans-serif;
  margin: 2px;
  text-align: left;
  > strong {
    color: white;
    margin-right: 1rem;
    margin-left: 1rem;
  }
`;

class FooterPlayer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      playPauseIcon: 'far fa-play',
      songProgress: 0,
      playIconLeft: '1rem',
      firstMount: true,
      firstAutoPlay: false
    };
    this.interval = null;
  }

  componentDidMount() {
    // const {componentPlaying, playPause, domRef} =
    // this.props.music.audioPlayerState; if (playPause === 'play' &&
    // componentPlaying === 'footer') {   this .props     .player     .playAudio();
    // this.setState({firstMount: false}); }

    this._handleAudioPlay();
  }

  componentDidUpdate(prevProps) {
    console.debug("FooterPlayer Component->componentDidUpdate");
    this._handleAudioPlay(prevProps);
  }

  _handleAudioPlay(prevProps) {
    const {trackID, domRef} = this.props.music.audioPlayerState;
    const a = domRef();
    console.debug("FooterPlayer Component->_handleAudioPlay: Different track?", prevProps
      ? [prevProps.music.audioPlayerState.trackID, trackID]
      : 'No');
    if (prevProps && prevProps.music.audioPlayerState.trackID !== trackID) {
      console.debug("FooterPlayer Component->_handleAudioPlay: Different track");
      // this   .props   .player   .pauseAudio();
      this
        .props
        .player
        .resetAudio();
      this
        .props
        .player
        .playAudio();
    }
    if (a) {
      this
        .props
        .player
        .handleProgress(a, this);

      if (a.currentTime >= a.duration) {
        if (this.interval) {
          clearInterval(this.interval);
        }
      }
    }
  }

  _onlyPlayAudio = () => {
    console.debug("FooterPlayer Component->_onlyPlayAudio");
    this
      .props
      .player
      .pauseAudio(false)
    this
      .props
      .player
      .playAudio();
  };

  _onlyStopAudio = () => {
    console.debug("FooterPlayer Component->_onlyStopAudio");
    this
      .props
      .player
      .resetAudio();
  };

  _playAudio = () => {
    console.debug("FooterPlayer Component->this.props.player._playAudio");
    this
      .props
      .player
      .pausePlayAudio()
  };

  _pauseAudio = () => {
    console.debug("FooterPlayer Component->_pauseAudio");
    this
      .props
      .player
      .pauseAudio()
  };

  _songEnded = () => {
    console.debug("FooterPlayer Component->_songEnded");
    this
      .props
      .player
      .updateAudio({playPauseIcon: 'far fa-play', songProgress: 0, playIconLeft: '1rem'});
  };

  _stopAndClosePlayer = () => {
    console.debug("FooterPlayer Component->_stopAndClosePlayer");
    const {domRef} = this.props.music.audioPlayerState;
    this
      .props
      .player
      .pauseAudio();
    this
      .props
      .player
      .resetAudio({audio: domRef(), showFooterPlayer: false});
  };

  _renderArtistLinks = (artist) => {
    const artists = artist.split(',');
    return artists.map((name, index) => <Link to={'/?s=' + name} key={name}>{name}{index < artists.length - 1
        ? ','
        : ''}</Link>);
  };

  render() {
    const {currentTrackAdvancedData, audioPlayerState, currentTrackBasicData} = this.props.music;
    const {item, currentIcon} = audioPlayerState;
    let shortName = item.title
      ? item.title
      : currentTrackAdvancedData
        ? currentTrackAdvancedData.meta.data.title
        : currentTrackBasicData
          ? currentTrackBasicData.title
          : '';
    if (shortName) {
      if (shortName.length > 25) {
        shortName = shortName
          .substring(0, 25)
          .trim();
        shortName += '...';
      }
    }

    return (
      <FooterWrapper>
        <StyledInnerContainer>
          <PlayIconCircle onClick={() => this.props.player.pausePlayAudio()}>
            <PlayIcon
              name={currentIcon}
              cssleft={audioPlayerState.isPlaying
              ? '0.7rem'
              : '1rem'}/>
          </PlayIconCircle>
          <StyledTrackInfoDiv>
            <BodyText>
              <Link to={"/track/?id=" + item.id}>
                <b>
                  {item || currentTrackAdvancedData || currentTrackBasicData.artist
                    ? shortName
                    : ''}
                </b>
              </Link>
              <strong>&bull;</strong>
              {this._renderArtistLinks(item.artist
                ? item.artist
                : currentTrackAdvancedData
                  ? currentTrackAdvancedData.meta.data.artist
                  : '')}
            </BodyText>
            <StyledProgressLine
              percent={this.state.songProgress}
              strokeWidth="1"
              strokeColor="#580f0f"/>
            <StyledTimelineTextDiv>
              <StyledTimelineText>{this.state.currentTime}</StyledTimelineText>
              <StyledTimelineText>0:30</StyledTimelineText>
            </StyledTimelineTextDiv>
          </StyledTrackInfoDiv>
          <FilterSearchButton type="button" onClick={this._stopAndClosePlayer}/>
        </StyledInnerContainer>
      </FooterWrapper>
    );
  }
}

const mapToProps = state => ({music: state.music});

export default connect(mapToProps)(FooterPlayer);



// WEBPACK FOOTER //
// ./src/components/FooterPlayer.js